import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { lighten } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';

const styles = {
  root: {
    width: '100%',
    marginTop: '20px'
  },
  paper: {
    height: '350px',
    width: '300px',
    padding: '20px',
    textAlign: 'center'
  },
  box: {
    padding: '10px'
  },
  boxHeadline: {
    textTransform: 'capitalize',
    margin: 0,
    color: 'text.primary',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    lineHeight: '1.6',
    letterSpacing: '0.0075em',
  },
  price: {
    marginTop: '20px',
    marginBottom: '10px',
    color: 'text.primary',
    fontSize: '2.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    lineHeight: '1.6',
    letterSpacing: '0.0075em',
  },
  words: {
    marginTop: '20px',
    marginBottom: '10px',
    color: 'text.primary',
    fontSize: '1.55rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    lineHeight: '1.6',
    letterSpacing: '0.0075em',
  },
  confirmButton: {
    marginTop: '40px',
    background: '#009900',
    color: '#ffffff',
    '&:hover': {
      background: '#009900',
      color: '#ffffff',
    }
  },
  checkIcon: {
    fontSize: '60px',
    color: '#009900'
  },
};

class RechargeConfirmation extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: true
    }
  }

  close = () => {
    window.history.pushState('name', '', window.location.href.split("?")[0]);
    this.setState({visible:false})
  }

  render() {
    const { rows, contained } = this.props;

    return (
      <Dialog
        sx={styles.dialog}
        onClose={this.close}
        aria-labelledby="customized-dialog-title"
        open={this.state.visible}
        maxWidth={'lg'}
        fullWidth={false}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            padding: '10px'
          }
        }}
        // BackdropProps mit festem Weiss entfernt: das MuiBackdrop-Override in
        // theme.js ist bereits modusabhängig und greift jetzt auch hier.
      >
        <Grid id={'boxes'} container alignItems={'center'} justifyContent="center" onClick={(e) => {if(e.target.id == 'boxes') {this.close()}}}>
          <Grid sx={styles.box}>
            <Paper sx={styles.paper}>
              <h6 style={styles.boxHeadline}>{this.props.plan}</h6>
              <div><CheckIcon sx={styles.checkIcon}/></div>
              <div style={styles.words}>{this.props.words} words</div>
              <div> have been successfully added to your autotranslations account</div>
              <Button onClick={(e) => {this.close()}} variant="contained" color="primary" type="submit" size="medium" sx={styles.confirmButton}>
                Continue
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Dialog>
    );
  }
}
export default RechargeConfirmation;
